export default __webpack_public_path__ + "c2bf1c0bf160fdb29da7afcabfd51c75.png";